import { render, staticRenderFns } from "./SinglePagePart.vue?vue&type=template&id=d58cb798&"
import script from "./SinglePagePart.vue?vue&type=script&lang=js&"
export * from "./SinglePagePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d58cb798')) {
      api.createRecord('d58cb798', component.options)
    } else {
      api.reload('d58cb798', component.options)
    }
    module.hot.accept("./SinglePagePart.vue?vue&type=template&id=d58cb798&", function () {
      api.rerender('d58cb798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/SinglePagePart.vue"
export default component.exports